import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PageContainer } from '@/components/layout/PageContainer';
import { CheckCircle2 } from 'lucide-react';

export default function ForProducersQualifySuccess() {
  return (
    <PageContainer className="max-w-md mx-auto py-6">
      <div className="space-y-6 py-8 text-center">
        <CheckCircle2 className="h-12 w-12 text-primary mx-auto" />

        <h1 className="font-display text-2xl text-foreground leading-tight">
          Tack — din intresseanmälan är skickad
        </h1>

        <p className="text-sm text-muted-foreground leading-relaxed">
          Vi har fått din intresseanmälan och hör av oss inom några dagar.
        </p>

        <p className="text-xs text-muted-foreground leading-relaxed">
          Ingen registrering har skapats ännu. Vi går igenom allt tillsammans först.
        </p>

        <div className="pt-4 space-y-3">
          <Button asChild className="w-full h-11">
            <Link to="/">Till startsidan</Link>
          </Button>

          <Button asChild variant="ghost" className="w-full h-11 text-sm">
            <Link to="/for-producers/qualify">Skicka en ny intresseanmälan</Link>
          </Button>
        </div>
      </div>
    </PageContainer>
  );
}
